<template>
  <div class="pt-2" style="background: #f0f0f0;font-family: PingFangSC-Medium, PingFang SC;height: 100%;padding: 10px;">
    <v-card flat>
      <div style="padding: 10px;">
        <el-button type="danger" @click="back" icon="el-icon-back">返回</el-button>
      </div>
      <div style="margin-top: 15px;min-height: 500px;padding: 10px;">
        <table-merge
            :table-data="tableData"
            :table-field="tableField"
            :table-config="tableConfig"
            :page-info="pageInfo">
          <div slot="opera" slot-scope="{ item }">
            暂无
          </div>
        </table-merge>
      </div>
    </v-card>
  </div>
</template>

<script>
import TableMerge from "../../../../components/elTable/tableMerge";
import GrouponApi from "../../../../api/sm/market/groupon/grouponApi"
export default {
  name: "grouponPrintList",
  components: {
    TableMerge
  },
  props: {
    page: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tableConfig: {
        isCheckBox: 0,
        isOpera: 1
      },
      tableData: [],
      tableField: [
        {columnCode: 'id',columnName: '券编号', isSlot: 0, width: 200},
        {columnCode: 'printName',columnName: '打印员', isSlot: 0, width: 200},
        {columnCode: 'printTime',columnName: '打印时间', isSlot: 0, width: 200}
      ],
      pageInfo: {
        pageSize: ''
      },
    }
  },
  created() {
  },
  mounted() {
    this.getPrintList()
  },
  methods: {
    back() {
      this.$emit('back', {formStatus: 'list'})
    },
    getPrintList() {
      let that = this

      GrouponApi.printRecordList(this.item.id).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.tableData = res.data
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
        alert('系统错误，请稍后尝试')
      })
    }
  }
}
</script>

<style scoped>

</style>